function init() {
    const playBtn: HTMLImageElement = document.getElementsByClassName('btn-play')[0] as HTMLImageElement;
    const videoCover: HTMLDivElement = document.getElementsByClassName('video-cover')[0] as HTMLDivElement;
    const video: HTMLVideoElement = document.getElementById('video') as HTMLVideoElement;
    
    if (!video || !videoCover || !playBtn) {
        return;
    }

    playBtn.addEventListener('click', () => {
        video.controls = true;
        playBtn.style.display = videoCover.style.display = 'none';
        if (video.paused) {
            video.play();
        }
    });

    video.addEventListener('ended', () => {
        video.controls = false;
        playBtn.style.display = videoCover.style.display = 'block';
    })
}

export default {
    init,
};
